import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	unitCreatorUi: {
		position: 'fixed',
		display: 'flex',
		alignItems: 'center',
		margin: '0 0rem',
		top: 0,
		left: '36rem',
		height: '10vh',
		zIndex: 2
	},
	sectionSwitchDropDown: {
		borderRight: `1px solid ${theme.palette.primary.grey} !important`,
		borderLeft: `1px solid ${theme.palette.primary.grey} !important`,
		height: '100%'
	},
	processStatusDiv: {
		display: 'flex',
		position: 'absolute',
		top: '3rem',
		right: '6rem',
		alignItems: 'center',
		gap: '1rem'
	},
	finalOverview: {
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70% !important',
		height: '70% ',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		overflow: 'hidden',
		position: 'relative'
	},
	finalOverviewContent: {
		height: '100%',
		boxSizing: 'border-box',
		padding: '3rem',
		overflow: 'auto'
	}
}));
